<top-navig transparent="true" [displayFam]="true" [transp]="true" [displayLogo]="true" [b_bottom]="true"
    displaySing="true" (openFilterFamEv)="openModalFam(template)"></top-navig>
<div class="home">
    <div class="slider-description">
        <div class="sou-d">
            <div>
                <img src="assets/images/logo/logo.png" class="logoHome" alt="logo">
                <a (click)="goToCarte()" class="add-to-cart btn">
                    Commander
                </a>
                <a href="https://www.burgerbynight16.fr/" target="_blank" class="add-to-cart btn">
                    Une faim de nuit ?
                </a>
                <div class="gradient-border" id="imgbox" *ngIf="enablePayement">
                    <img src="assets/imgs/payementbanner.jpg" alt="Paiement par carte bancaire">
                </div>
            </div>
        </div>
    </div>
    <products></products>
    <menus></menus>
    <div style="display: none">
        <table>
            <thead>
                <th>Zone</th>
                <th>Min de commande</th>
            </thead>
            <tbody>
                <tr *ngFor="let zone of authorizedCities">
                    <td>
                        <a href="/commander/livraison-{{pdv.speciality}}-{{ zone.name | lowercase }}-{{
                            zone.postalCode
                          }}" title="livraison {{zone.name}} {{zone.postalCode}}">{{zone.name}}
                            {{zone.postalCode}}</a>
                    </td>
                    <td class="text-center">{{zone.amountMiniDelivery}}€</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<ng-template #template>
    <div class="modal-body">
        <ng-container *ngFor="let family of families;let i=index">
            <label class="container" (click)="selectFam(family)">
                <img class="img img-filter" width="28px;" [src]="family.avatar|absolutePath :'families'"
                    [alt]="family.label">
                {{family.label}}
            </label>
        </ng-container>
    </div>
</ng-template>